import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const tlSection = document.querySelectorAll('.timeline-section');

    tlSection.forEach(section => {
        const tlThumbSlider = section.querySelector('.ts-tab-slider');
        const tlMainSlider = section.querySelector('.ts-content-slider');

        const maintlThumbSlider = new Swiper(tlThumbSlider, {
            slidesPerView: 'auto',
            spaceBetween: 34,
        });

        new Swiper(tlMainSlider, {
            slidesPerView: 1,
            spaceBetween: 16,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            thumbs: {
                swiper: maintlThumbSlider,
            },
            allowTouchMove: false,
            navigation: {
                prevEl: section.querySelector('.ts-arrow-prev'),
                nextEl: section.querySelector('.ts-arrow-next'),
            },
        });
    });
});
